import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5484_9745)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#ECEDEE"
      />
    </g>
    <defs>
      <clipPath id="clip0_5484_9745">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
